/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { PointFStruct } from './point-fstruct';

export class IOSScreenModeProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): IOSScreenModeProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIOSScreenModeProto(
    bb: flatbuffers.ByteBuffer,
    obj?: IOSScreenModeProto,
  ): IOSScreenModeProto {
    return (obj || new IOSScreenModeProto()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsIOSScreenModeProto(
    bb: flatbuffers.ByteBuffer,
    obj?: IOSScreenModeProto,
  ): IOSScreenModeProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new IOSScreenModeProto()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  pixelSize(obj?: PointFStruct): PointFStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? (obj || new PointFStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  pixelAspectRatio(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
  }

  static startIOSScreenModeProto(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addPixelSize(builder: flatbuffers.Builder, pixelSizeOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, pixelSizeOffset, 0);
  }

  static addPixelAspectRatio(builder: flatbuffers.Builder, pixelAspectRatio: number) {
    builder.addFieldFloat32(1, pixelAspectRatio, 0.0);
  }

  static endIOSScreenModeProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createIOSScreenModeProto(
    builder: flatbuffers.Builder,
    pixelSizeOffset: flatbuffers.Offset,
    pixelAspectRatio: number,
  ): flatbuffers.Offset {
    IOSScreenModeProto.startIOSScreenModeProto(builder);
    IOSScreenModeProto.addPixelSize(builder, pixelSizeOffset);
    IOSScreenModeProto.addPixelAspectRatio(builder, pixelAspectRatio);
    return IOSScreenModeProto.endIOSScreenModeProto(builder);
  }
}
